module.exports = __webpack_public_path__ + "img/item_summary.989dded0.jpg";